import { render, staticRenderFns } from "./TVLInfo.vue?vue&type=template&id=13a2b186&scoped=true&"
import script from "./TVLInfo.vue?vue&type=script&lang=js&"
export * from "./TVLInfo.vue?vue&type=script&lang=js&"
import style0 from "./TVLInfo.vue?vue&type=style&index=0&id=13a2b186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a2b186",
  null
  
)

export default component.exports